let items = []

class InMemoryLibraryService {
    getItems() {
        return Promise.resolve(items)
    }

    setItems(data) {
        items = data
    }

    saveItem(id, name, state) {
        if (!id) {
            let item = {
                id: items.length + 1,
                name,
                state,
            }

            items.push(item)

            return Promise.resolve(item)
        }

        const idx = items.findIndex(item => item.id === id)

        if (idx || idx < 0) {
            return Promise.reject()
        }

        const item = items[idx]

        items[idx] = {
            ...item,
            ...{
                name,
                state,
            },
        }
    }

    deleteItem(id) {
        items = items.filter(item => item.id !== id)

        return Promise.resolve()
    }
}

export default InMemoryLibraryService
